if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /** Copy
         *
         * Copy a node and add it after the original
         *
         * @param node - original node to copy -- add attribute data-target="id-of-node-to-copy" if this is the trigger
         *                                     -- add attribute data-max-copies="10" for maximum of (e.g. 10) copies (-1 is infinite and default)
         *                                     -- add attribute data-copy-delete-text="delete-text" for text on delete button (default 'verwijder')
         *                                     -- add attribute data-copy-original-state="[hidden/visible]" for initial state of original node (default 'visible')
         -- add attribute data-init-interactions="[true(empty)/false]" for init any js interactions for the new copy (default 'true(empty)')
         * @param trigger - (optional) trigger for copy action
         * @constructor
         * Different ways to call constructor:
         * - new ZZ.Copy(node-to-copy, trigger) -- node is copied after click on trigger
         * - new ZZ.Copy(trigger)               -- trigger has ref to node (attribute data-target="id-of-node" or href="#id-of-node")
         * - new ZZ.Copy(node-to-copy)          -- node is copied instantly
         *
         * - Use class name 'no-copy' on a child node to prevent copying the contents of the node
         * - Use 'data-copy-iterate' attribute on elements containing a number that needs updating after each copy (e.g. <span data-copy-iterate>0</span>)
         */
        ZZ.Copy = function(node, trigger) {
            var base = this;

            if (
                node.attr("data-copy-original-state") !== "undefined" &&
                node.attr("data-copy-original-state") === "hidden" &&
                node.attr("data-copy-startId") !== "undefined" &&
                !isNaN(parseInt(node.attr("data-copy-startId")))
            ) {
                base.curCloneId = parseInt(node.attr("data-copy-startId"));
            } else {
                base.curCloneId = 0;
            }

            base.removeOneCopyataTime =
                node.attr("data-remove-one-copyatatime") !== undefined ||
                node.attr("data-remove-one-copyatatime") ||
                false;

            base.clones = [];
            base.config = $.extend({}, base._defaultConfig, node.data());

            // check if there is a trigger
            base.trigger = trigger;
            if (typeof this.trigger === "undefined") {
                if (
                    typeof node.attr("href") !== "undefined" &&
                    $(node.attr("href")).length > 0
                ) {
                    base.trigger = node;
                    base.original = $(node.attr("href"));
                } else if (typeof node.attr("data-target") !== "undefined") {
                    base.trigger = node;
                    base.original = $("#" + node.attr("data-target"));
                } else {
                    base.original = node;
                }
            }

            var initialCopies = base.original.nextAll("[data-copy-id]");
            var initialCopiesLength = initialCopies.length;
            if (initialCopiesLength > 0) {
                var curCopy;
                base.curCloneId = parseInt(
                    $(initialCopies[initialCopiesLength - 1]).attr(
                        "data-copy-id"
                    ),
                    10
                );
                for (var i = 0; i < initialCopiesLength; i++) {
                    curCopy = $(initialCopies[i]);
                    base.clones.push({
                        id: curCopy.attr("data-copy-id"),
                        copy: curCopy
                    });
                }
                base.checkMaximum();
            }

            base.clone = base.original.clone().removeAttr("id");
            base.deleteBtn = $(
                '<a class="delete-copy" href="#">' +
                    base.config.copyDeleteText +
                    "</a>"
            );

            // filter no-copy elements
            var noCopy = base.clone.find(".no-copy");
            noCopy.each(function(index, elem) {
                /[(UL)]/.test(elem.tagName.toUpperCase())
                    ? noCopy.empty()
                    : noCopy.remove();
            });

            // if there is no trigger, copy instantly
            if (typeof base.trigger === "undefined") {
                base.copy();
            } else {
                base.assignListeners();
            }

            // keep global track of number of copies via data attribute on original element
            base.original.attr("data-number-of-copies", base.clones.length);
            base.original.trigger("init");

            if (base.config.copyOriginalState === "hidden") {
                base.original.hide(0);
            }
        };

        ZZ.Copy.prototype = {
            _defaultConfig: {
                copyDeleteText: "verwijder",
                maxCopies: -1,
                copyOriginalState: "visible"
            },

            assignListeners: function() {
                var base = this;

                base.trigger.on("click", function(e) {
                    e.preventDefault();
                    base.copy();
                });

                for (var i = 0; i < base.clones.length; i++) {
                    $(base.clones[i].copy)
                        .find("[data-delete-id]")
                        .on("click", this.deleteCopyClick.bind(this));
                }

                // set inputs of original to disabled before submit, if they are originally hidden, so they won't get posted to the server
                base.original.closest("form").on("submit", function() {
                    if (base.config.copyOriginalState === "hidden") {
                        base.original.find(":input").prop("disabled", true);
                    }
                });
            },

            copy: function() {
                var base = this;
                var newClone = base.clone.clone();
                var newDeleteBtn = newClone.find(".delete-copy");

                if (newDeleteBtn.length === 0) {
                    newDeleteBtn = base.deleteBtn.clone();
                }

                var curSibling;

                if (
                    base.config.maxCopies > -1 &&
                    base.clones.length >= base.config.maxCopies
                ) {
                    return;
                }

                base.curCloneId++;

                // find next sibling to put new copy after
                if (base.clones.length > 0) {
                    curSibling = base.clones[base.clones.length - 1].copy;
                } else {
                    curSibling = base.original;
                }

                // make sure names and id's remain unique
                base.updateIds(newClone);
                base.updateInputNames(newClone);

                // add delete button
                newDeleteBtn.attr("data-delete-id", base.curCloneId);
                newDeleteBtn.on("click", this.deleteCopyClick.bind(this));

                //only remove 1 copy at a time
                if (base.removeOneCopyataTime) {
                    for (var i = base.clones.length - 1; i >= 0; i--) {
                        base.clones[i].copy.find(".delete-copy").hide();
                    }
                }
                // append new copy
                newClone.attr("data-copy-id", base.curCloneId);
                newClone.hide();
                if (newClone.find(".delete-copy").length === 0) {
                    newClone.append(newDeleteBtn);
                }
                curSibling.after(newClone);
                newClone.fadeIn(150);

                // init any js interactions for the new copy
                base.initInteractions(newClone);

                // add to list of copies
                base.clones.push({ id: base.curCloneId, copy: newClone });

                base.updateIteratingNumericValues();

                if (base.config.maxCopies > -1) {
                    base.checkMaximum();
                }
                // update number of copies and trigger change for possible attached events
                base.original.attr("data-number-of-copies", base.clones.length);
                base.original.trigger("change");
            },

            checkMaximum: function() {
                var base = this;
                if (
                    base.config.maxCopies > -1 &&
                    base.clones.length >= base.config.maxCopies
                ) {
                    if (typeof base.trigger !== "undefined") {
                        base.trigger.hide();
                    }
                    return false;
                } else {
                    if (typeof base.trigger !== "undefined") {
                        base.trigger.show();
                    }
                    return true;
                }
            },

            // update id's to keep them unique
            updateIds: function(clone) {
                var base = this,
                    idNodes = clone.find("[id]"),
                    conditionalVisibleNodes = clone.find(
                        "[data-only-visible-if]"
                    ),
                    conditionalDisabledNodes = clone.find("[data-disable-if]"),
                    cloneId,
                    curId,
                    newId;

                clone.removeAttr("id");
                idNodes.each(function(index, item) {
                    curId = $(item).attr("id");
                    newId = curId + base.curCloneId;
                    // find labels that are linked to the an element with the specific id
                    clone.find("[for=" + curId + "]").attr("for", newId);
                    $(item).attr("id", newId);
                });
                conditionalVisibleNodes.each(function(index, item) {
                    var splitName = $(item)
                        .attr("data-only-visible-if")
                        .split("=");
                    $(item).attr(
                        "data-only-visible-if",
                        splitName[0] + base.curCloneId + "=" + splitName[1]
                    );
                });
                conditionalDisabledNodes.each(function(index, item) {
                    var splitName = $(item)
                        .attr("data-disable-if")
                        .split("=");
                    $(item).attr(
                        "data-disable-if",
                        splitName[0] + base.curCloneId + "=" + splitName[1]
                    );
                });
            },

            // update names of input fields, if the name contains an underscore _ or brackets []
            updateInputNames: function(clone) {
                var base = this,
                    nameNodes = clone.find("[name]:input"),
                    curName,
                    curItem;

                nameNodes.each(function(index, item) {
                    curItem = $(item);
                    // if name has an underscore, put id behind the underscore 'name_id'
                    if (curItem.attr("name").indexOf("_") > -1) {
                        curName = $(item)
                            .attr("name")
                            .split("_", 1)[0];
                        $(item).attr("name", curName + "_" + base.curCloneId);
                    }
                    // if name has brackets, put id between brackets name[id]
                    else if (curItem.attr("name").indexOf("[") > -1) {
                        var splitName = $(item)
                            .attr("name")
                            .split("[");
                        curName = splitName[0];
                        var nameTail = splitName[1].substring(
                            splitName[1].indexOf("]"),
                            splitName[1].length
                        );
                        $(item).attr(
                            "name",
                            curName + "[" + base.curCloneId + nameTail
                        );
                    }
                });
            },

            // update any numeric values marked by data-copy-iterate attribute on containing element
            updateIteratingNumericValues: function() {
                var base = this,
                    numberOfClones = base.clones.length,
                    numericElems,
                    numericElemsOriginal = base.original.find(
                        "[data-copy-iterate]"
                    ),
                    curVal,
                    isNumber = /^[0-9]*$/,
                    i;

                for (i = 0; i < numberOfClones; i++) {
                    numericElems = base.clones[i].copy.find(
                        "[data-copy-iterate]"
                    );
                    numericElems.each(function(index, elem) {
                        curVal = numericElemsOriginal[index].innerHTML;
                        if (isNumber.test(curVal)) {
                            // new value = original value + nth clone
                            curVal = parseInt(curVal, 10) + (i + 1);
                            elem.innerHTML = curVal;
                        }
                    });
                }
            },

            initInteractions: function(clone) {
                clone.removeAttr("data-initialized");
                clone.find("[data-initialized]").removeAttr("data-initialized");
                clone.find(".hasDatepicker").removeClass("hasDatepicker");

                ZZ.init(clone.get(0));

                new ZZ.FormInteraction(clone);

                if (clone.find("input[data-validate=true]").length > 0) {
                    ZZ.FormValidationHandler.prototype.reAssignValidationListeners(
                        clone
                    );
                }

                // trigger custom event for binding of other interaction
                clone.trigger("ZZ_new-copy");
            },

            deleteCopyClick: function(e) {
                e.preventDefault();
                this.deleteCopy($(e.currentTarget).attr("data-delete-id"));
            },

            deleteCopy: function(copyId) {
                var base = this,
                    delCopy,
                    id = parseInt(copyId, 10);

                for (var i = 0; i < base.clones.length; i++) {
                    if (parseInt(base.clones[i].id, 10) === id) {
                        delCopy = base.clones.splice(i, 1)[0];
                        break;
                    }
                }
                delCopy = delCopy.copy;

                $(window).trigger("zz_delete_copy", delCopy);
                //delCopy.slideUp(150, function () {
                delCopy.remove();
                base.updateIteratingNumericValues();
                //});

                if (base.config.maxCopies > -1) {
                    base.checkMaximum();
                }

                //show delete btn of last active copy
                if (
                    base.removeOneCopyataTime &&
                    $(base.clones).last()[0] !== undefined
                ) {
                    $(base.clones)
                        .last()[0]
                        .copy.find(".delete-copy")
                        .show();
                }
                // update number of copies and trigger change for possible attached events
                base.original.attr("data-number-of-copies", base.clones.length);
                base.original.trigger("change");
            }
        };
    })(jQuery);
}
